// extracted by mini-css-extract-plugin
module.exports = {"slackAltCTAContainer":"SlackAltCTA_slackAltCTAContainer__0uS3V","slackAltDividerContainer":"SlackAltCTA_slackAltDividerContainer__ATMdw","title":"SlackAltCTA_title__UnvJi"};